import React                from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { Translate }        from 'react-localize-redux';
import { Link }             from 'gatsby';
import styled               from 'styled-components';

import Heading              from '../../components/heading';

const Button = styled(Link)`
  text-decoration: none;
  color          : ${props => props.theme.primary};
  position       : fixed;
  bottom         : -4em;
  right          : -4em;
  z-index        : 3;
  background     : black;
  border         : ${props => props.theme.primary} 0.7em solid;
  padding        : 2em 3em 5em 1em;
  border-radius  : 50%;
  font-size      : 0.8em;
  width          : 15em;
  height         : 15em;
  display        : flex;
  align-items    : center;
  flex-direction : column;
  justify-content: space-around;
  > h4 {
    margin-bottom: 1em;
  }
`;

const Animation = styled.div`
  @keyframes pulse {
    from { transform: scale3d(1, 1, 1);       }
    50%  { transform: scale3d(1.1, 1.1, 1.1); }
    to   { transform: scale3d(1, 1, 1);       }
  }
  font-weight: bold;
  margin-left: 0.4em;
  animation  : pulse 3s infinite;
`;

const BookButton = ({ gameId }) => (
  <Button to={`/games/${gameId}/calendar/`}>
    <Heading fontSize="1.5em">
      <Animation>
        <Translate id="landingPage.book.nextStepShort" />
      </Animation>
    </Heading>
    <FaRegCalendarAlt size="4em" />
  </Button>
);

export default BookButton;
